export const findStatus = (projectStatuses, projectStatusId) => {
  return projectStatuses.find((s) => s.id === projectStatusId);
};

export const filterProjectsByIds = (allProjects, portfolioProjectIds) => {
  if (!portfolioProjectIds || !portfolioProjectIds.length) return [];
  return allProjects.filter((p) => portfolioProjectIds.includes(p.id));
};

export const filterPortfoliosBySearch = (
  portfolios,
  searchResult,
  isNoParentPortfolio = false
) => {
  return (portfolios || []).filter((p) => {
    // For regular parent portfolios, exclude no_portfolio
    if (!isNoParentPortfolio && p.id === 'no_portfolio') return false;
    // For no_parent_portfolio, include no_portfolio along with other portfolios
    return searchResult.some((sp) => sp.id === p.id) || p.id === 'no_portfolio';
  });
};
